import { AppError, ErrorCode } from '../types';

export function fromFunctionsError(err: any): AppError {
  const code = String(err?.code ?? '');
  const message = err?.message || '';
  
  // Check for HTTP status codes in the error
  if (err?.status === 429 || code === 'RATE_LIMITED' || message.toLowerCase().includes('rate limit') || message.toLowerCase().includes('too many')) {
    return new AppError({ 
      code: ErrorCode.UNKNOWN, 
      domain: 'functions', 
      cause: err,
      message: message || 'Too many requests. Please wait before trying again.'
    });
  }
  
  if (code === 'unavailable') return new AppError({ code: ErrorCode.FUNC_UNAVAILABLE, domain: 'functions', cause: err, message });
  if (code === 'invalid-argument') return new AppError({ code: ErrorCode.FUNC_INVALID_ARGUMENT, domain: 'functions', cause: err, message });
  
  // Preserve the original message if available
  return new AppError({ 
    code: ErrorCode.UNKNOWN, 
    domain: 'functions', 
    cause: err,
    message: message || 'An error occurred'
  });
}
